"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var qs_1 = __importDefault(require("qs"));
var api_base_1 = __importDefault(require("./api_base"));
var api_base_2 = __importDefault(require("../api_base"));
exports.default = {
    get: function (organizationId, params) {
        var query = qs_1.default.stringify(params);
        return Promise.all([
            api_base_1.default.get("organizations/" + organizationId + "/incentive_performance?" + query),
            api_base_2.default.get("organizations/" + organizationId + "/vocabulary")
        ]).then(function (_a) {
            var report = _a[0], vocabulary = _a[1];
            return {
                data: report.data.data,
                totalPages: report.data.meta.total_pages,
                totalRecords: report.data.meta.total_records,
                vocabulary: vocabulary.data.data
            };
        });
    }
};
//# sourceMappingURL=incentive_performance.js.map